export default __webpack_public_path__ + "static/media/picelectic.8d67bf2d.jpg";